import React, { useEffect, useState } from 'react'
import { Carousel as CarouselBootstrap, Modal } from 'react-bootstrap'
import '../../styles/Utils/Carousel.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faMouse, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Gallery } from "react-grid-gallery"
import { Fade } from 'react-awesome-reveal'
import { isMobile } from 'react-device-detect'

function Carousel({ data, title }) {

    const [CarouselIndex, setCarouselIndex] = useState(0)
    const [fullscreenDisplay, setFullscreenDisplay] = useState(false)
    const [imagesGallery, setImagesGallery] = useState([])

    useEffect(() => {

        imageGalleryFormat()

        // eslint-disable-next-line
    }, [])

    async function imageGalleryFormat() {

        const imagesFormat = await Promise.all(
            data.map(async (item, index) => {
                return new Promise((resolve) => {
                    const img = new Image()
                    const randomNumber = Math.floor(Math.random() * 61) - 30
                    img.onload = () => {
                        if (index === 0) {
                            resolve({
                                ...item,
                                height: img.height / 10,
                                width: img.width / 10 + randomNumber
                            })
                        } else {
                            resolve({
                                ...item,
                                height: img.height,
                                width: img.width
                            })
                        }
                    }
                    img.src = item.src
                })
            })
        )
        var tab1 = []
        var tab2 = []
        var tab3 = []
        var tab4 = []
        var tab5 = []
        imagesFormat.map((item, index) => {
            if (index < 20) {
                tab1.push(item)
            } else if (index < 40) {
                tab2.push(item)
            } else if (index < 60) {
                tab3.push(item)
            } else if (index < 80) {
                tab4.push(item)
            } else if (index < 100) {
                tab5.push(item)
            }
            return item
        })
        setImagesGallery(imagesFormat)

    }

    return (

        <>
            <div className='carousel'>
                <div className='carouselCenter' onClick={() => setFullscreenDisplay(true)}>
                    <div className='carouselCenterButton'>
                        <FontAwesomeIcon icon={faMouse} className='carouselCenterButtonIcon' />
                        Plein écran
                    </div>
                </div>
                <CarouselBootstrap
                    interval={6000}
                    activeIndex={CarouselIndex}
                    prevIcon={<div className='carouselControlButtonLeft'><FontAwesomeIcon icon={faChevronLeft} className='carouselControlButtonIcon' /></div>}
                    nextIcon={<div className='carouselControlButtonRight'><FontAwesomeIcon icon={faChevronRight} className='carouselControlButtonIcon' /></div>}
                    onSelect={(value) => setCarouselIndex(value)}>
                    {data.map((item, index) => {
                        return (
                            <CarouselBootstrap.Item key={index}>
                                {item.label ?
                                    <div className='carouselItemLabel'>{item.label}</div>
                                    : null
                                }
                                <img src={item.src} height={!isMobile ? 700 : 200} alt={item.label ? item.label : 'carouselItem-' + index} />
                            </CarouselBootstrap.Item>
                        )
                    })}
                </CarouselBootstrap>
            </div>
            <Modal show={fullscreenDisplay} onHide={() => setFullscreenDisplay(false)} fullscreen={true}>
                <div className="carouselFullscreen">
                    <Fade duration={500}>
                        <div className='carouselFullscreenClose' onClick={() => setFullscreenDisplay(false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </div>
                    </Fade>
                    <div className='carouselFullscreenTitle'>{title}</div>
                    <CarouselBootstrap
                        interval={6000}
                        activeIndex={CarouselIndex}
                        prevIcon={<div className='carouselControlButtonLeft'><FontAwesomeIcon icon={faChevronLeft} className='carouselControlButtonIcon' /></div>}
                        nextIcon={<div className='carouselControlButtonRight'><FontAwesomeIcon icon={faChevronRight} className='carouselControlButtonIcon' /></div>}
                        onSelect={(value) => setCarouselIndex(value)}>
                        {data.map((item, index) => {
                            return (
                                <CarouselBootstrap.Item key={index}>
                                    {item.label ?
                                        <div className='carouselItemLabel'>{item.label}</div>
                                        : null
                                    }
                                    <img src={item.src} height={!isMobile ? (window.innerHeight * 80 / 100) - 100 : 300} alt={item.label ? item.label + "Fullscreen" : 'carouselItem-' + index + "Fullscreen"} />
                                </CarouselBootstrap.Item>
                            )
                        })}
                    </CarouselBootstrap>
                </div>
                <div className="carouselFullscreenGallery">
                    <Gallery
                        images={imagesGallery}
                        enableImageSelection={false}
                        onClick={(index, image) => { setCarouselIndex(index); document.querySelector('.carouselFullscreen').scrollIntoView({ behavior: 'smooth' }) }}
                    />
                </div>
            </Modal>
        </>

    )

}

export default Carousel